import { Col, Input, Row } from 'antd';
import React, { useEffect } from 'react';
import { useGlobalState } from './GlobalState';

function Step1({
  form,
  preFillData = null,
  disabled = false,
  loggedIn = false,
}) {
  const [formState, setFormState] = useGlobalState('formState');
  useEffect(() => {
    if (preFillData) {
      setFormState((prevState) => ({
        ...prevState,
        first_name: preFillData.first_name,
        last_name: preFillData.last_name,
        email: preFillData.email,
        contact: preFillData.contact,
      }));
    }
  }, [preFillData, setFormState]);

  return (
    <div style={{ color: '#606060' }}>
      <div className='fs-24 gSemiBold'>Full Name:</div>
      <Row gutter={[10, 10]} className='mg-bottom-20'>
        <Col xs={24} sm={12}>
          <Input
            aria-labelledby='first_name__label'
            name='first_name'
            id='first_name'
            disabled={disabled}
            className='mg-bottom-10 gMedium input-fs'
            value={formState.first_name}
            onChange={(e) =>
              setFormState((prevState) => ({
                ...prevState,
                first_name: e.target.value,
              }))
            }
          />
          <label className='gMedium' id='first_name__label'>
            First Name
          </label>
        </Col>
        <Col xs={24} sm={12}>
          <Input
            aria-labelledby='last_name__label'
            name='last_name'
            id='last_name'
            disabled={disabled}
            className='mg-bottom-10 gMedium input-fs'
            value={formState.last_name}
            onChange={(e) =>
              setFormState((prevState) => ({
                ...prevState,
                last_name: e.target.value,
              }))
            }
          />
          <label className='gMedium' id='last_name__label'>
            Last Name
          </label>
        </Col>
      </Row>
      <Row gutter={[10, 10]} className='mg-bottom-20'>
        <Col xs={24} sm={12}>
          <div className='fs-24 gSemiBold'>Email Address</div>

          <Input
            className='mg-bottom-10 gMedium input-fs'
            type='email'
            disabled={loggedIn}
            onChange={(e) =>
              setFormState((prevState) => ({
                ...prevState,
                email: e.target.value,
              }))
            }
            style={{ height: 40 }}
            value={formState?.email}
          />
          <div className='gMedium'>example@example.com</div>
        </Col>
        {form?.form_element.phone_number && (
          <Col xs={24} sm={12}>
            <div className='fs-24 gSemiBold'>Phone Number</div>
            <Input
              type='number'
              onKeyDown={(e) => {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                  e.preventDefault(); // Disable arrow keys
                }
              }}
              disabled={disabled}
              onWheel={(e) => e.preventDefault()} // Disable mouse wheel
              value={formState.contact}
              className='mg-bottom-10 gMedium input-fs'
              onChange={(e) =>
                setFormState((prevState) => ({
                  ...prevState,
                  contact: e.target.value,
                }))
              }
            />
            {!disabled && (
              <div className='gMedium'>Please enter a valid phone number</div>
            )}
          </Col>
        )}
      </Row>
    </div>
  );
}

export default Step1;
